(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["age-gate"]) return;
  try {
    
  (function(){
    var gate = document.getElementById('otlAgeGate');
    if (!gate) return;

    var STORAGE_KEY = 'otl_age_verified_at';
    var MAX_AGE_MS = 1000 * 60 * 60 * 24 * 30; // 30 days

    function isVerified(){
      try{
        var stamp = localStorage.getItem(STORAGE_KEY);
        if (!stamp) return false;
        return (Date.now() - parseInt(stamp, 10)) < MAX_AGE_MS;
      }catch(e){
        return false;
      }
    }

    if (isVerified()) {
      gate.setAttribute('hidden', '');
    } else {
      document.body.classList.add('otl-age-locked');
    }

    var yesBtn = document.getElementById('otlAgeYes');
    var noBtn = document.getElementById('otlAgeNo');

    if (yesBtn){
      yesBtn.addEventListener('click', function(){
        try{ localStorage.setItem(STORAGE_KEY, Date.now().toString()); }catch(e){}
        gate.setAttribute('hidden', '');
        document.body.classList.remove('otl-age-locked');
      });
    }
    if (noBtn){
      noBtn.addEventListener('click', function(){
        window.location.href = 'https://www.drinkaware.co.uk/';
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-forms"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-contact-forms').forEach(function(section){
    var tabGeneral = section.querySelector('#otlTabGeneral');
    var tabTrade = section.querySelector('#otlTabTrade');
    var panelGeneral = section.querySelector('#otlPanelGeneral');
    var panelTrade = section.querySelector('#otlPanelTrade');

    function showGeneral(){
      tabGeneral.classList.add('otl-tab-active');
      tabTrade.classList.remove('otl-tab-active');
      tabGeneral.setAttribute('aria-selected', 'true');
      tabTrade.setAttribute('aria-selected', 'false');
      panelGeneral.hidden = false;
      panelTrade.hidden = true;
    }
    function showTrade(){
      tabTrade.classList.add('otl-tab-active');
      tabGeneral.classList.remove('otl-tab-active');
      tabTrade.setAttribute('aria-selected', 'true');
      tabGeneral.setAttribute('aria-selected', 'false');
      panelTrade.hidden = false;
      panelGeneral.hidden = true;
    }
    if (tabGeneral) tabGeneral.addEventListener('click', showGeneral);
    if (tabTrade) tabTrade.addEventListener('click', showTrade);

    // Build mailto: links from data attributes after page load, so
    // the raw address never appears in the page's HTML source.
    section.querySelectorAll('.otl-email-link').forEach(function(link){
      var addr = link.dataset.user + '@' + link.dataset.domain;
      link.href = 'mailto:' + addr;
      link.textContent = addr;
    });

    // Prefix the message body with the enquiry tag on submit, since
    // Shopify's contact[body] field is what actually shows first in
    // the notification email.
    section.querySelectorAll('form').forEach(function(form){
      form.addEventListener('submit', function(){
        var prefixField = form.querySelector('input[name="contact[body_prefix]"]');
        var bodyField = form.querySelector('textarea[name="contact[body]"]');
        if (prefixField && bodyField) {
          bodyField.value = '(' + prefixField.value + ')\n\n' + bodyField.value;
        }
      });
    });

    // Push trade enquiries into Klaviyo before the native Shopify
    // submit navigates away. The contact form has no server-side
    // Klaviyo connection, so this client-side push is the only way
    // this data reaches Klaviyo at all.
    var tradeForm = section.querySelector('#otl-trade-form');
    if (tradeForm) {
      tradeForm.addEventListener('submit', function(e){
        if (typeof klaviyo === 'undefined') return; // fail open, don't block the enquiry

        e.preventDefault();

        var email = tradeForm.querySelector('#otl-t-email').value;
        var name = tradeForm.querySelector('#otl-t-name').value;
        var business = tradeForm.querySelector('#otl-t-business').value;
        var type = tradeForm.querySelector('#otl-t-type').value;
        var frequency = tradeForm.querySelector('#otl-t-volume').value;

        klaviyo.identify({
          email: email,
          first_name: name,
          'Business Name': business,
          'Business Type': type,
          'Order Frequency': frequency
        });

        klaviyo.track('Trade Enquiry Submitted', {
          business_name: business,
          business_type: type,
          order_frequency: frequency
        });

        setTimeout(function(){
          tradeForm.submit();
        }, 300);
      });
    }

    // Same pattern for the general/press form.
    var generalForm = section.querySelector('#otl-general-form');
    if (generalForm) {
      generalForm.addEventListener('submit', function(e){
        if (typeof klaviyo === 'undefined') return; // fail open, don't block the enquiry

        e.preventDefault();

        var email = generalForm.querySelector('#otl-g-email').value;
        var name = generalForm.querySelector('#otl-g-name').value;
        var topic = generalForm.querySelector('#otl-g-topic').value;

        klaviyo.identify({
          email: email,
          first_name: name
        });

        klaviyo.track('General Enquiry Submitted', {
          topic: topic
        });

        setTimeout(function(){
          generalForm.submit();
        }, 300);
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cinematic-video"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-cinematic-hero').forEach(function(hero){
    if (hero.getAttribute('data-otl-skip') === '1') return;

    var video = hero.querySelector('.otl-cinematic-video');
    if (!video) return;

    var collapsed = false;
    function collapse(){
      if (collapsed) return;
      collapsed = true;
      clearTimeout(safetyTimer);
      var h = hero.getBoundingClientRect().height;
      hero.style.height = h + 'px';
      void hero.offsetHeight;
      requestAnimationFrame(function(){
        hero.style.height = '0px';
        hero.style.opacity = '0';
      });
      try { sessionStorage.setItem('otlIntroPlayed', '1'); } catch(e){}
    }

    // Never get stuck, whatever happens with the video.
    var safetyTimer = setTimeout(collapse, 12000);

    video.addEventListener('ended', collapse);
    video.addEventListener('error', collapse);

    video.load();
    var playPromise = video.play();
    if (playPromise && playPromise.catch) {
      playPromise.catch(collapse);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-quiz"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-hero').forEach(function(hero){
    var sectionId = hero.dataset.sectionId;
    var chips = hero.querySelectorAll('.otl-chip');
    var quizBlock = hero.querySelector('.otl-quiz-block');
    var manifestReveal = hero.querySelector('.otl-manifest-reveal');
    var manifestItems = hero.querySelectorAll('.otl-manifest li');
    var destSpan = hero.querySelector('[id^="otlDestSpan-"]');
    var heroMark = hero.querySelector('.otl-hero-mark');
    var scrollHint = hero.querySelector('.otl-scroll-hint');
    var againBtn = hero.querySelector('.otl-again');

    chips.forEach(function(chip){
      chip.addEventListener('click', function(){
        chips.forEach(function(c){ c.classList.remove('otl-selected'); });
        chip.classList.add('otl-selected');

        var match = chip.dataset.match;
        var dest = chip.dataset.dest;

        quizBlock.classList.add('otl-answered');
        manifestReveal.classList.add('otl-show');

        manifestItems.forEach(function(li, i){
          li.classList.remove('otl-struck','otl-kept','otl-matched');
          li.style.transitionDelay = (i * 110) + 'ms';
          var key = li.dataset.key;
          var statusEl = li.querySelector('.otl-status');
          var originalStatus = li.dataset.originalStatus || (statusEl ? statusEl.textContent : '');

          if (key === 'struck') {
            li.classList.add('otl-struck');
            if (statusEl) statusEl.textContent = originalStatus;
          } else if (key === match) {
            li.classList.add('otl-kept','otl-matched');
            if (statusEl) statusEl.textContent = 'Matched to you';
          } else {
            li.classList.add('otl-kept');
            if (statusEl) statusEl.textContent = originalStatus;
          }
        });

        if (destSpan) destSpan.textContent = 'Into ' + dest + '.';

        if (heroMark) {
          heroMark.classList.remove('otl-stamp');
          void heroMark.offsetWidth;
          heroMark.classList.add('otl-stamp');
        }

        if (scrollHint) scrollHint.classList.add('otl-show');
      });
    });

    if (againBtn) {
      againBtn.addEventListener('click', function(){
        chips.forEach(function(c){ c.classList.remove('otl-selected'); });
        quizBlock.classList.remove('otl-answered');
        manifestReveal.classList.remove('otl-show');
        if (scrollHint) scrollHint.classList.remove('otl-show');
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-speakeasy-photo"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-hero-speak').forEach(function(hero){
    var doorLayer = hero.querySelector('.otl-door-layer');
    if (!doorLayer) return;

    var stage = hero.querySelector('.otl-door-photo-stage');
    var peephole = hero.querySelector('.otl-peephole');
    var knockKnock = hero.querySelector('.otl-knock-knock');
    var hint = hero.querySelector('.otl-door-hint');
    var openSrc = stage.dataset.openSrc;
    var knocks = 0;

    if (peephole && openSrc) {
      var afterStyle = document.createElement('style');
      document.head.appendChild(afterStyle);

      function updatePeephole(clientX, clientY, isTouch){
        var r = stage.getBoundingClientRect();
        var x = clientX - r.left;
        var y = clientY - r.top;
        var displayY = isTouch ? y - 90 : y;
        peephole.style.left = (x - 60) + 'px';
        peephole.style.top = (displayY - 60) + 'px';
        peephole.style.opacity = '1';
        afterStyle.textContent =
          '#' + peephole.id + '::after{ background-image:url(' + openSrc + ');' +
          'background-size:' + r.width + 'px ' + r.height + 'px;' +
          'background-position:' + (-(x - 60)) + 'px ' + (-(y - 60)) + 'px; }';
      }

      stage.addEventListener('mousemove', function(e){
        updatePeephole(e.clientX, e.clientY, false);
      });
      stage.addEventListener('mouseleave', function(){
        peephole.style.opacity = '0';
      });
      stage.addEventListener('touchstart', function(e){
        var t = e.touches[0];
        if (t) updatePeephole(t.clientX, t.clientY, true);
      }, { passive: true });
      stage.addEventListener('touchmove', function(e){
        var t = e.touches[0];
        if (t) updatePeephole(t.clientX, t.clientY, true);
      }, { passive: true });
      stage.addEventListener('touchend', function(){
        peephole.style.opacity = '0';
      });
    }

    function knock(){
      if (stage.classList.contains('otl-open')) return;
      knocks++;
      stage.classList.remove('otl-knock');
      void stage.offsetWidth;
      stage.classList.add('otl-knock');

      if (knocks === 1) {
        if (knockKnock) knockKnock.textContent = knockKnock.dataset.step2 || "Who's there?";
        if (hint) hint.textContent = hint.dataset.step2 || 'Knock again.';
      }
      if (knocks >= 2) {
        stage.classList.add('otl-open');
        if (knockKnock) knockKnock.textContent = knockKnock.dataset.step3 || 'Come on in.';
        if (hint) hint.style.opacity = '0';
        setTimeout(function(){
          if (knockKnock) knockKnock.style.opacity = '0';
        }, 300);
        setTimeout(function(){
          doorLayer.classList.add('otl-fade');
          try { localStorage.setItem('otl_door_seen', '1'); } catch(e){}
        }, 1400);
      }
    }

    stage.addEventListener('click', knock);
    stage.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); knock(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-speakeasy-responsive"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-hero-speak').forEach(function(hero){
    var doorLayer = hero.querySelector('.otl-door-layer');
    if (!doorLayer) return;

    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
    var stage = isDesktop
      ? hero.querySelector('.otl-door-stage-desktop')
      : hero.querySelector('.otl-door-stage-mobile');
    if (!stage) return;

    var knockKnock = hero.querySelector('.otl-knock-knock');
    var hint = hero.querySelector('.otl-door-hint');
    var knocks = 0;

    if (isDesktop) {
      // Only now do we fetch the door photos — mobile never requests them.
      stage.querySelectorAll('img[data-src]').forEach(function(img){
        img.src = img.dataset.src;
      });

      var peephole = hero.querySelector('.otl-peephole');
      var openSrc = peephole ? peephole.dataset.openSrc : null;
      if (peephole && openSrc) {
        var afterStyle = document.createElement('style');
        document.head.appendChild(afterStyle);

        stage.addEventListener('mousemove', function(e){
          var r = stage.getBoundingClientRect();
          var x = e.clientX - r.left;
          var y = e.clientY - r.top;
          peephole.style.left = (x - 60) + 'px';
          peephole.style.top = (y - 60) + 'px';
          peephole.style.opacity = '1';
          afterStyle.textContent =
            '#' + peephole.id + '::after{ background-image:url(' + openSrc + ');' +
            'background-size:' + r.width + 'px ' + r.height + 'px;' +
            'background-position:' + (-(x - 60)) + 'px ' + (-(y - 60)) + 'px; }';
        });
        stage.addEventListener('mouseleave', function(){
          peephole.style.opacity = '0';
        });
      }
    }

    function knock(){
      if (stage.classList.contains('otl-open')) return;
      knocks++;
      stage.classList.remove('otl-knock');
      void stage.offsetWidth;
      stage.classList.add('otl-knock');

      if (knocks === 1) {
        if (knockKnock) knockKnock.textContent = knockKnock.dataset.step2 || "Who's there?";
        if (hint) hint.textContent = hint.dataset.step2 || 'Knock again.';
      }
      if (knocks >= 2) {
        stage.classList.add('otl-open');
        if (knockKnock) knockKnock.textContent = knockKnock.dataset.step3 || 'Come on in.';
        if (hint) hint.style.opacity = '0';
        setTimeout(function(){
          if (knockKnock) knockKnock.style.opacity = '0';
        }, 300);
        setTimeout(function(){
          doorLayer.classList.add('otl-fade');
          try { localStorage.setItem('otl_door_seen', '1'); } catch(e){}
        }, 1400);
      }
    }

    stage.addEventListener('click', knock);
    stage.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); knock(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-speakeasy"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-hero-speak').forEach(function(hero){
    var doorLayer = hero.querySelector('.otl-door-layer');
    if (!doorLayer) return;

    var stage = hero.querySelector('.otl-door-stage');
    var peephole = hero.querySelector('.otl-peephole');
    var knockKnock = hero.querySelector('.otl-knock-knock');
    var hint = hero.querySelector('.otl-door-hint');
    var knocks = 0;

    stage.addEventListener('mousemove', function(e){
      var r = stage.getBoundingClientRect();
      peephole.style.left = (e.clientX - r.left - 60) + 'px';
      peephole.style.top = (e.clientY - r.top - 60) + 'px';
    });

    function knock(){
      if (stage.classList.contains('otl-open')) return;
      knocks++;
      stage.classList.remove('otl-knock');
      void stage.offsetWidth;
      stage.classList.add('otl-knock');

      if (knocks === 1) {
        stage.classList.add('otl-crack');
        if (knockKnock) knockKnock.textContent = knockKnock.dataset.step2 || "Who's there?";
        if (hint) hint.textContent = hint.dataset.step2 || 'Knock again.';
      }
      if (knocks >= 2) {
        if (knockKnock) knockKnock.textContent = knockKnock.dataset.step3 || 'Come on in.';
        if (hint) hint.style.opacity = '0';
        setTimeout(function(){
          stage.classList.remove('otl-crack');
          stage.classList.add('otl-open');
          if (knockKnock) knockKnock.style.opacity = '0';
        }, 300);
        setTimeout(function(){
          doorLayer.classList.add('otl-fade');
          try { localStorage.setItem('otl_door_seen', '1'); } catch(e){}
        }, 1200);
      }
    }

    stage.addEventListener('click', knock);
    stage.addEventListener('keydown', function(e){
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); knock(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["statement-section"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-statement').forEach(function(el){
    if (!('IntersectionObserver' in window)) {
      el.classList.add('otl-in-view');
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          el.classList.add('otl-in-view');
          io.unobserve(el);
        }
      });
    }, { threshold: 0.2 });
    io.observe(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tastings-guess-pour"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.otl-guess').forEach(function(section){
    var hint = section.querySelector('[id^="otlGuessHint-"]');
    section.querySelectorAll('.otl-bottle').forEach(function(b){
      b.addEventListener('click', function(){
        b.classList.toggle('otl-flipped');
        if (hint) hint.textContent = b.dataset.clue;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
